/* eslint-disable import/prefer-default-export */
export const carotidas = {
    scan: {
        velocidade: [
            {
                CODVELOCIDADE: 1,
                VELOCIDADE: 'sem causar alteração do fluxo',
            },
            {
                CODVELOCIDADE: 2,
                VELOCIDADE: 'sem causar alteração significativa do fluxo',
            },
            {
                CODVELOCIDADE: 3,
                VELOCIDADE: 'causando discreto aumento da velocidade do fluxo',
            },
            {
                CODVELOCIDADE: 4,
                VELOCIDADE:
                    'causando discreto aumento da velocidade do fluxo, estenose não significativa.',
            },
            {
                CODVELOCIDADE: 5,
                VELOCIDADE:
                    'causando aumento da velocidade do fluxo, correspondendo a estenose',
            },
            {
                CODVELOCIDADE: 6,
                VELOCIDADE: 'com fluxo apresentando baixa velocidade.',
            },
            {
                CODVELOCIDADE: 7,
                VELOCIDADE: 'Vide observações.',
            },
            {
                CODVELOCIDADE: 8,
                VELOCIDADE: 'levando a obstrução total e ausência de fluxo',
            },
            {
                CODVELOCIDADE: 9,
                VELOCIDADE: 'com fluxo filamentar compatível com suboclusão',
            },
            {
                CODVELOCIDADE: 10,
                VELOCIDADE:
                    'sendo a maior no terço proximal, levando a aumento da velocidade do fluxo e correspondendo a estenose',
            },
            {
                CODVELOCIDADE: 11,
                VELOCIDADE:
                    'sendo a maior no terço médio, levando a aumento da velocidade do fluxo e correspondendo a estenose',
            },
            {
                CODVELOCIDADE: 12,
                VELOCIDADE:
                    'sendo a maior no terço distal, levando a aumento da velocidade do fluxo e correspondendo a estenose',
            },
            {
                CODVELOCIDADE: 13,
                VELOCIDADE: 'nota-se fluxo retrógrado distal ao ponto de oclusão',
            },
            {
                CODVELOCIDADE: 14,
                VELOCIDADE: 'presença de fluxo anterógrado',
            },
            {
                CODVELOCIDADE: 15,
                VELOCIDADE:
                    'sem causar alteração significativa do fluxo, correspondendo a estenose',
            },
        ],
        intensidade: [
            {
                CODINTENSIDADE: 1,
                INTENSIDADE: 'discreta.',
            },
            {
                CODINTENSIDADE: 2,
                INTENSIDADE: 'moderada.',
            },
            {
                CODINTENSIDADE: 3,
                INTENSIDADE: 'importante.',
            },
            {
                CODINTENSIDADE: 4,
                INTENSIDADE: 'discreta menor que 40%.',
            },
            {
                CODINTENSIDADE: 5,
                INTENSIDADE: 'discreta de aproximadamente 40%.',
            },
            {
                CODINTENSIDADE: 6,
                INTENSIDADE: 'de aproximadamente 50%.',
            },
            {
                CODINTENSIDADE: 7,
                INTENSIDADE: 'discreta de aproximadamente 60%.',
            },
            {
                CODINTENSIDADE: 8,
                INTENSIDADE: 'moderada de aproximadamente 60%.',
            },
            {
                CODINTENSIDADE: 9,
                INTENSIDADE: 'moderada de aproximadamente 70%.',
            },
            {
                CODINTENSIDADE: 10,
                INTENSIDADE: 'moderada de aproximadamente 80%.',
            },
            {
                CODINTENSIDADE: 11,
                INTENSIDADE: 'moderada a importante de aproximadamente 80%.',
            },
            {
                CODINTENSIDADE: 12,
                INTENSIDADE: 'importante de aproximadamente 90%.',
            },
            {
                CODINTENSIDADE: 13,
                INTENSIDADE: 'importante de aproximadamente 95%.',
            },
            {
                CODINTENSIDADE: 14,
                INTENSIDADE: 'severa de aproximadamente 95%.',
            },
            {
                CODINTENSIDADE: 15,
                INTENSIDADE: 'severa de aproximadamente 99%.',
            },
            {
                CODINTENSIDADE: 16,
                INTENSIDADE: 'entre 1% e 15%',
            },
            {
                CODINTENSIDADE: 17,
                INTENSIDADE: 'entre 16% e 49%',
            },
            {
                CODINTENSIDADE: 18,
                INTENSIDADE: 'entre 50% e 69%',
            },
            {
                CODINTENSIDADE: 19,
                INTENSIDADE: 'entre 70% e 90%',
            },
            {
                CODINTENSIDADE: 20,
                INTENSIDADE: 'maior que 70%',
            },
            {
                CODINTENSIDADE: 21,
                INTENSIDADE: 'maior que 90%',
            },
            {
                CODINTENSIDADE: 22,
                INTENSIDADE: 'maior que 90% (suboclusão)',
            },
            {
                CODINTENSIDADE: 23,
                INTENSIDADE: 'menor que 50%',
            },
            {
                CODINTENSIDADE: 24,
                INTENSIDADE: 'maior que 50%',
            },
            {
                CODINTENSIDADE: 25,
                INTENSIDADE:
                    'De acordo com o Estudo ELSA-BRASIL, a medida da espessura encontra-se Normal para sexo, idade e etnia.',
            },
            {
                CODINTENSIDADE: 26,
                INTENSIDADE:
                    'De acordo com o Estudo ELSA-BRASIL, a medida da espessura encontra-se Aumentada para sexo, idade e etnia.',
            },
        ],
        anatomia: [
            {
                CODANATOMIA: 1,
                ANATOMIA: 'Anatomia e fluxos normais.',
            },
            {
                CODANATOMIA: 2,
                ANATOMIA: 'Espessamento da camada íntima',
            },
            {
                CODANATOMIA: 3,
                ANATOMIA:
                    'Espessamento da camada íntima e discretas irregularidades difusas',
            },
            {
                CODANATOMIA: 4,
                ANATOMIA: 'Irregularidades difusas',
            },
            {
                CODANATOMIA: 5,
                ANATOMIA: 'Pequenas placas e irregularidades difusas',
            },
            {
                CODANATOMIA: 6,
                ANATOMIA: 'Irregularidades difusas e placa fixa no terço proximal',
            },
            {
                CODANATOMIA: 7,
                ANATOMIA: 'Irregularidades difusas e placa fixa no terço médio',
            },
            {
                CODANATOMIA: 8,
                ANATOMIA: 'Irregularidades difusas e placa fixa no terço distal',
            },
            {
                CODANATOMIA: 9,
                ANATOMIA: 'Irregularidades difusas e placa ulcerada no terço proximal',
            },
            {
                CODANATOMIA: 10,
                ANATOMIA: 'Irregularidades difusas e placa ulcerada no terço médio',
            },
            {
                CODANATOMIA: 11,
                ANATOMIA: 'Irregularidades difusas e placa ulcerada no terço distal',
            },
            {
                CODANATOMIA: 12,
                ANATOMIA: 'Presença de placa fixa no terço proximal',
            },
            {
                CODANATOMIA: 13,
                ANATOMIA: 'Presença de placa fixa no terço médio',
            },
            {
                CODANATOMIA: 14,
                ANATOMIA: 'Presença de placa fixa no terço distal',
            },
            {
                CODANATOMIA: 15,
                ANATOMIA: 'Presença de placa ulcerada no terço proximal',
            },
            {
                CODANATOMIA: 16,
                ANATOMIA: 'Presença de placa ulcerada no terço médio',
            },
            {
                CODANATOMIA: 17,
                ANATOMIA: 'Presença de placa ulcerada no terço distal',
            },
            {
                CODANATOMIA: 18,
                ANATOMIA: 'Presença de placa fixa na região do bulbo',
            },
            {
                CODANATOMIA: 19,
                ANATOMIA: 'Presença de placa ulcerada na região do bulbo',
            },
            {
                CODANATOMIA: 20,
                ANATOMIA: 'Presença de KINKING (dobra) no terço proximal',
            },
            {
                CODANATOMIA: 21,
                ANATOMIA: 'Presença de KINKING (dobra) no terço médio',
            },
            {
                CODANATOMIA: 22,
                ANATOMIA: 'Presença de KINKING (dobra) no terço distal',
            },
            {
                CODANATOMIA: 23,
                ANATOMIA: 'Presença de tortuosidades (KINKING) difusas',
            },
            {
                CODANATOMIA: 24,
                ANATOMIA: 'Ausência de fluxo, com obstrução total no terço proximal',
            },
            {
                CODANATOMIA: 25,
                ANATOMIA: 'Ausência de fluxo, com obstrução total no terço médio.',
            },
            {
                CODANATOMIA: 26,
                ANATOMIA: 'Ausência de fluxo, com obstrução total no terço distal',
            },
            {
                CODANATOMIA: 27,
                ANATOMIA: 'Presença de STENT bem posicionado',
            },
            {
                CODANATOMIA: 28,
                ANATOMIA: 'Presença de STENT com estenose residual',
            },
            {
                CODANATOMIA: 29,
                ANATOMIA: 'Não visualizada neste exame.',
            },
            {
                CODANATOMIA: 30,
                ANATOMIA: 'Vide observações.',
            },
            {
                CODANATOMIA: 31,
                ANATOMIA: 'Presença de placas e irregularidades difusas',
            },
            {
                CODANATOMIA: 32,
                ANATOMIA: 'Presença de placas difusas com superfícies irregulares',
            },
            {
                CODANATOMIA: 33,
                ANATOMIA: 'Presença de placa homogênea no terço proximal',
            },
            {
                CODANATOMIA: 34,
                ANATOMIA: 'Presença de placa homogênea no terço médio',
            },
            {
                CODANATOMIA: 35,
                ANATOMIA: 'Presença de placa homogênea no terço distal',
            },
            {
                CODANATOMIA: 36,
                ANATOMIA: 'Presença de placa heterogênea no terço proximal',
            },
            {
                CODANATOMIA: 37,
                ANATOMIA: 'Presença de placa heterogênea no terço médio',
            },
            {
                CODANATOMIA: 38,
                ANATOMIA: 'Presença de placa heterogênea no terço distal',
            },
            {
                CODANATOMIA: 39,
                ANATOMIA:
                    'Presença de placa extensa que se prolonga em direção aos ramos',
            },
            {
                CODANATOMIA: 40,
                ANATOMIA:
                    'Presença de placa extensa que se prolonga em direção a carótida interna',
            },
            {
                CODANATOMIA: 41,
                ANATOMIA:
                    'Presença de placa extensa que se prolonga em direção a carótida externa',
            },
            {
                CODANATOMIA: 42,
                ANATOMIA: 'Não visualizado todos os segmentos e trajeto desta artéria',
            },
            {
                CODANATOMIA: 43,
                ANATOMIA:
                    'Presença de pequenas placas sem causar obstrução significativa',
            },
            {
                CODANATOMIA: 44,
                ANATOMIA:
                    'Espessura média da camada médio-intimal na parede posterior da artéria carótida comum mede=',
            },
            {
                CODANATOMIA: 45,
                ANATOMIA: 'Placa extensa e homogênea',
            },
        ],
    }
};